<template>
    <div class="component">
        <h1>Aktueller Status</h1>
        <div class="status-boxes">
            <div v-for="( set, key ) in template" class="status-box">
                <div :class="'status-icon '+icons[key]"></div>
                <h2>{{ key }}</h2>
                <div v-for="( setup, topic ) in set" class="status-row">
                    <div class="left"><strong>{{ setup.label }}</strong></div>
                    <div class="right">
                        <template v-if="values[topic]">
                            {{ values[ topic ].payload }} {{ setup.unit }}
                        </template>
                        <template v-else>
                            n/a
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Status',
    data()
    {
        return {
            icons   : {
                'Pufferspeicher'                   : 'battery',
                'Heizkreislauf 1 - Heizkörper'     : 'heating',
                'Heizkreislauf 2 - Fußbodenheizung': 'floorheater',
                'Wärmeerzeugung Extern'            : 'externalheating',
                'UPGRAIT HeatControl'              : 'heatcontrol',
                'Elektrische Versorgung'           : 'power'
            },
            template: {
                'Pufferspeicher'                   : {
                    'hal/reservoir/1/t_top'   : {
                        label  : 'Speichertemperatur oben',
                        unit   : '°C',
                        display: 'number',
                        format : 'float'
                    },
                    'hal/reservoir/1/t_bottom': {
                        label  : 'Speichertemperatur unten',
                        unit   : '°C',
                        display: 'number',
                        format : 'float'
                    }
                },
                'Heizkreislauf 1 - Heizkörper'     : {
                    'hal/circuits/1/a_pump'         : {
                        label  : 'Pumpe',
                        unit   : undefined,
                        display: 'switch',
                        format : 'bool'
                    },
                    'hal/circuits/1/t_forerun'      : {
                        label  : 'Vorlauftemperatur IST',
                        unit   : '°C',
                        display: 'number',
                        format : 'float'
                    },
                    'hal/circuits/1/desired_forerun': {
                        label  : 'Vorlauftemperatur SOLL',
                        unit   : '°C',
                        display: 'number',
                        format : 'float'
                    },
                    'hal/circuits/1/t_backrun'      : {
                        label  : 'Rücklauf',
                        unit   : '°C',
                        display: 'number',
                        format : 'float'
                    }
                },
                'Heizkreislauf 2 - Fußbodenheizung': {
                    'hal/circuits/2/a_pump'         : {
                        label  : 'Pumpe',
                        unit   : undefined,
                        display: 'switch',
                        format : 'bool'
                    },
                    'hal/circuits/2/t_forerun'      : {
                        label  : 'Vorlauftemperatur IST',
                        unit   : '°C',
                        display: 'number',
                        format : 'float'
                    },
                    'hal/circuits/2/desired_forerun': {
                        label  : 'Vorlauftemperatur SOLL',
                        unit   : '°C',
                        display: 'number',
                        format : 'float'
                    },
                    'hal/circuits/2/t_backrun'      : {
                        label  : 'Rücklauf',
                        unit   : '°C',
                        display: 'number',
                        format : 'float'
                    }
                },
                'Wärmeerzeugung Extern'            : {
                    'hal/heaters/2/t_forerun': {
                        label  : 'Vorlauf externer Erzeuger',
                        unit   : '°C',
                        display: 'number',
                        format : 'float'
                    },
                    'hal/heaters/2/a_stop'   : {
                        label  : 'Übertemperatur',
                        unit   : undefined,
                        display: 'switch',
                        format : 'bool'
                    },
                },
                'UPGRAIT HeatControl'              : {
                    'powermeter/total_import'    : {
                        label  : 'Gesamtverbrauch',
                        unit   : 'kWh',
                        display: 'number',
                        format : 'float'
                    },
                    'powermeter/total_power'     : {
                        label  : 'Gesamtleistung',
                        unit   : 'W',
                        display: 'number',
                        format : 'float'
                    },
                    'hal/heaters/1/thermaloutput': {
                        label  : 'Heizstab',
                        unit   : 'W',
                        display: 'number',
                        format : 'float'
                    },
                    'hal/heaters/1/mode'         : {
                        label  : 'Aktueller Modus', /** COMMENT: FOR FUTURE USE **/
                        unit   : undefined,
                        display: undefined,
                        format : undefined
                    }
                },
                'Elektrische Versorgung'           : {
                    'powermeter/L1_voltage': {
                        label  : 'L1',
                        unit   : 'V',
                        display: 'number',
                        format : 'int'
                    },
                    'powermeter/L2_voltage': {
                        label  : 'L2',
                        unit   : 'V',
                        display: 'number',
                        format : 'int'
                    },
                    'powermeter/L3_voltage': {
                        label  : 'L3',
                        unit   : 'V',
                        display: 'number',
                        format : 'int'
                    },
                    'energy/gridWatts'     : {
                        label  : 'Netzbezug / -einspeisung',
                        unit   : 'W',
                        display: 'number',
                        format : 'float'
                    },
                    'energy/gridCurrent'   : {
                        label  : '',
                        unit   : 'A',
                        display: 'number',
                        format : 'float'
                    }
                },
            },
            values  : {}
        }
    },

    created()
    {
        let message = {
            method: 'uhc.getStatus',
            plain : false
        }
        
        this.$core
            .getWebsockets()
            .request( message )
            .then( response =>
            {
                if( undefined !== response )
                {
                    this.values = response
                }
            } )
            .catch( error => {
                this.$core.getLogger().cerror( 'Status.vue::websocketRequest', 'error: '+error )
            })
    },

    methods: {}
}
</script>